import { RichTextFooterItem } from '@framework/form';
import React from 'react';
import { useWatch } from 'react-hook-form';
import { InfoIcon } from '../../ui/info-icon';
import { renderRichTextAdvancedNodes } from './render/renderRichTextAdvancedNodes';

export interface InfoIconInputPreviewProps {
  name: string;
}

export function InfoIconInputPreview(props: InfoIconInputPreviewProps) {
  const { name } = props;
  const text = useWatch({ name });
  return (
    <RichTextFooterItem>
      Fai click sull’icona{' '}
      <InfoIcon text={renderRichTextAdvancedNodes(text, true)} /> per
      visualizzare l’anteprima
    </RichTextFooterItem>
  );
}
